export default __webpack_public_path__ + "static/media/Kale-Closeup-100px.jpg.095b8189.webp";